export default {
    mounted(el, binding) {
        // Tooltip text and placement
        el._tooltipValue = binding.value;
        el._tooltipPlacement = binding.arg || "bottom";

        el._showTooltip = () => {
            if (!el._tooltipValue) return;

            const tooltip = document.createElement("div");
            tooltip.textContent = el._tooltipValue;
            tooltip.style.position = "absolute";
            tooltip.style.padding = "5px 8px";
            tooltip.style.background = "#FFF";
            tooltip.style.color = "#373D3F";
            tooltip.style.borderRadius = "8px";
            tooltip.style.zIndex = "1000";
            tooltip.style.fontSize = "12px";
            tooltip.style.fontWeight = "400";
            tooltip.style.boxShadow = "1px 2px 10px 0px #131E2726";
            tooltip.style.visibility = "hidden";

            document.body.appendChild(tooltip);
            el._tooltipElement = tooltip;

            // Measure tooltip size
            const rect = el.getBoundingClientRect();
            const ttRect = tooltip.getBoundingClientRect();
            const offset = 6;
            let top, left;

            switch (el._tooltipPlacement) {
                case "top":
                    top = window.scrollY + rect.top - ttRect.height - offset;
                    left = window.scrollX + rect.left + (rect.width - ttRect.width) / 2;
                    break;
                case "top-left":
                    top = window.scrollY + rect.top - ttRect.height - offset;
                    left = window.scrollX + rect.left;
                    break;
                case "top-right":
                    top = window.scrollY + rect.top - ttRect.height - offset;
                    left = window.scrollX + rect.right - ttRect.width;
                    break;
                case "bottom-left":
                    top = window.scrollY + rect.bottom + offset;
                    left = window.scrollX + rect.left;
                    break;
                case "bottom-right":
                    top = window.scrollY + rect.bottom + offset;
                    left = window.scrollX + rect.right - ttRect.width;
                    break;
                case "left-top":
                    top = window.scrollY + rect.top;
                    left = window.scrollX + rect.left - ttRect.width - offset;
                    break;
                case "left-bottom":
                    top = window.scrollY + rect.bottom - ttRect.height;
                    left = window.scrollX + rect.left - ttRect.width - offset;
                    break;
                case "right-top":
                    top = window.scrollY + rect.top;
                    left = window.scrollX + rect.right + offset;
                    break;
                case "right-bottom":
                    top = window.scrollY + rect.bottom - ttRect.height;
                    left = window.scrollX + rect.right + offset;
                    break;
                case "left":
                    top = window.scrollY + rect.top + (rect.height - ttRect.height) / 2;
                    left = window.scrollX + rect.left - ttRect.width - offset;
                    break;
                case "right":
                    top = window.scrollY + rect.top + (rect.height - ttRect.height) / 2;
                    left = window.scrollX + rect.right + offset;
                    break;
                case "bottom":
                default:
                    top = window.scrollY + rect.bottom + offset;
                    left = window.scrollX + rect.left + (rect.width - ttRect.width) / 2;
            }

            tooltip.style.top = `${top}px`;
            tooltip.style.left = `${left}px`;
            tooltip.style.visibility = "visible";
        };

        el._hideTooltip = () => {
            if (el._tooltipElement) {
                document.body.removeChild(el._tooltipElement);
                el._tooltipElement = null;
            }
        };

        el.addEventListener("mouseenter", el._showTooltip);
        el.addEventListener("mouseleave", el._hideTooltip);
        el.addEventListener("click", el._hideTooltip, true);
    },

    updated(el, binding) {
        el._tooltipValue = binding.value;
        el._tooltipPlacement = binding.arg || "bottom";

        // Hide current tooltip if visible and recreate it
        if (el._tooltipElement) {
            el._hideTooltip();
            // If mouse is still over element, show tooltip again
            if (el.matches(":hover")) {
                // Use setTimeout to ensure DOM is updated
                setTimeout(() => {
                    el._showTooltip();
                }, 0);
            }
        }
    },

    unmounted(el) {
        el.removeEventListener("mouseenter", el._showTooltip);
        el.removeEventListener("mouseleave", el._hideTooltip);
        el.removeEventListener("click", el._hideTooltip, true);
        if (el._tooltipElement) {
            document.body.removeChild(el._tooltipElement);
            el._tooltipElement = null;
        }
        delete el._showTooltip;
        delete el._hideTooltip;
        delete el._tooltipValue;
        delete el._tooltipPlacement;
    }
};
